var languageSwitchers = [].slice.call(document.querySelectorAll('.lang-button'));

languageSwitchers.forEach(function(switcher) {
	switcher.addEventListener('click', function(e) {
		var parent = this.parentNode,
			list = parent.querySelector('ul');

		closeDropDown(parent, e);

		parent.classList.toggle('open');

		Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'slideUp' : 'slideDown'), {duration: 150});
	});
});

body.addEventListener('click', function(e) {
	closeDropDown(this, e);
});

function closeDropDown(el, e) {
	var open = document.querySelector('.language-picker-container.open');

	if(open) {
		if(open !== el && !open.contains(e.target)) {
			open.classList.remove('open');
			Velocity(open.querySelector('ul'), 'slideUp', {duration: 150});
		}
	}
}

var languages = [].slice.call(document.querySelectorAll('.language-picker-container1 a'));

languages.forEach(function(language) {
	language.addEventListener('click', function(e) {
		e.preventDefault();

		var lang = this.getAttribute('hreflang');

		if(Cookie.get('language') !== lang) {
			googTransHandle(false, lang);

			var splitDomain = location.host.split('.');

			if(splitDomain.length > 2)
				googTransHandle(location.host.replace(splitDomain[0], ''), lang);

			window.location.reload();
		}
	});
});

function googTransHandle(domain, lang) {
	if(!domain) {
		if(typeof Cookie.get('googtrans')!=='undefined') {
			Cookie.remove('language');
			Cookie.remove('googtrans');
		}
		if(lang!=='en') {
			Cookie.set('language', lang);
			Cookie.set('googtrans', '/en/'+lang);
		}
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined') {
			Cookie.remove('language', {domain: domain});
			Cookie.remove('googtrans', {domain: domain});
		}
		if(lang!=='en') {
			Cookie.set('language', lang, {domain: domain});
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
		}
	}
}
